import { z } from 'zod';
import { DEFAULT_PAGE_SIZE } from './-constants';
export const PayrollItemsSearchSchema = z.object({
  freeText: z.string().default(''),
  /**
   * ページング値は URL から直接与えられるため、範囲を絞ってから使う。
   * `pageSize: 0` は総ページ数を Infinity にし、負の `pageIndex` は `slice` を
   * 空振りさせるため、どちらも一覧が空になる。不正値は既定値へ倒す
   *（throw するとルート自体がエラーになり、壊れ方が悪化する）。
   */
  pageIndex: z.number().int().nonnegative().catch(0).default(0),
  pageSize: z.number().int().positive().catch(DEFAULT_PAGE_SIZE).default(DEFAULT_PAGE_SIZE)
});
export type PayrollItemsSearchParams = z.infer<typeof PayrollItemsSearchSchema>;